import type { IconType } from '~/components/ui/Icons/Icons';
import SVGIcon from '~/components/ui/Icons/SVGIcon';

type TProps = {
  iconType: IconType;
  text: string;
};

const KeyInfoCard = ({ iconType, text }: TProps) => {
  return (
    <div className="col-6 col-md-4">
      <div className="key-info-card d-flex flex-column h-100 align-items-center justify-content-center fo-border-sm border-grey-200 p-3 rounded-3">
        <SVGIcon iconType={iconType} />
        <div className="text-center -regular mt-1">{text}</div>
      </div>
    </div>
  );
};

export default KeyInfoCard;
